import { BuildClass, Do, fsmData, timer } from '../../universal';
import { $, React, ReactDOM, ReactDOMClient, _ } from '../lib';
import { J2rButton } from './component-buttons';
import { J2rComboBox } from './component-combobox';
import { validateTime } from './component-main';
import { J2rListComponent } from './component-react-list';
import { newSystemFlyout } from './flyouts';
import { Bindings, ConditionalObject } from './ui5';
let debug_no_key = false;
export const toggleDebugNoKey = () => {
    debug_no_key = !debug_no_key;
    return debug_no_key;
};
window.reactComponents = [];
export const j2r = (objRaw, isGridCell) => {
    let objConcrete;
    if (isJSX(objRaw)) {
        return objRaw;
    }
    if (objRaw === undefined || objRaw === null) {
        return React.createElement(React.Fragment, null);
    }
    if (typeof objRaw === 'number') {
        console.error(`Number passed: ${objRaw}`);
        objConcrete = {
            tag: 'span',
            text: 'ERROR! NUMBER GIVEN!',
        };
    }
    if (typeof objRaw === 'function') {
        return j2r(objRaw(), isGridCell);
    }
    if (typeof objRaw === 'string') {
        return j2r({
            tag: 'span',
            key: objRaw,
            text: objRaw,
        }, isGridCell);
    }
    if (objRaw.constructor === Array) {
        return (React.createElement(React.Fragment, null, objRaw.filter(x => x != null).map(x => j2r(x, isGridCell))));
    }
    objConcrete = !('tag' in objRaw)
        ? { tag: 'div', ...objRaw }
        : { tag: objRaw.tag ?? 'div', ...objRaw };
    const is_sub_cmp = typeof objConcrete.tag !== 'string';
    const has_gridRow = objConcrete.cl != null && objConcrete.cl.indexOf('gridRow') !== -1;
    if (isGridCell) {
        objConcrete.cl = (objConcrete.cl ?? '').replace('gridCell', '');
        objConcrete.cl += ' gridCell';
        objConcrete.cl = objConcrete.cl.replace(/\s+/g, ' ');
        objConcrete.cl = objConcrete.cl.trim();
    }
    const children = objConcrete.text ??
        Do(() => {
            if (objConcrete.children != null) {
                const C = objConcrete.children
                    .filter(x => x != null)
                    .map(child => j2r(child, has_gridRow));
                return C;
            }
            return null;
        });
    const banned_fields = ['tag', 'children', 'text'];
    const attrObj = {};
    _.forEach(objConcrete, (v, k) => {
        if (k === 'cl') {
            attrObj['className'] = v;
            if (is_sub_cmp) {
                attrObj['cl'] = v;
            }
        }
        else if (!_.includes(banned_fields, k)) {
            attrObj[k] = v;
        }
    });
    if (debug_no_key && attrObj['key'] === undefined) {
        console.log(objRaw, objConcrete);
    }
    const attr = _.size(attrObj) === 0 ? null : attrObj;
    if (!children) {
        return React.createElement(objConcrete.tag, attr);
    }
    return React.createElement(objConcrete.tag, attr, children);
};
export const isJSX = (obj) => {
    if (_.isFunction(obj)) {
        return false;
    }
    if (typeof obj == 'string') {
        return false;
    }
    if (obj == null) {
        return false;
    }
    return (typeof obj === 'object' &&
        obj !== null &&
        '$$typeof' in obj &&
        obj['$$typeof'] != null);
};
class CustomReact18Wrapper extends React.Component {
    ref;
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    componentDidMount() {
        if (this.ref.current) {
            this.props.onMount(this.ref.current);
        }
    }
    render() {
        return React.cloneElement(this.props.children, {
            ref: this.ref,
        });
    }
    unmount() {
        this.props.root.unmount();
    }
}
export const reactRender = async (container, cmpt) => new Promise(resolve => {
    const root = ReactDOMClient.createRoot(container);
    const component = (React.createElement(CustomReact18Wrapper, { root: root, onMount: x => {
            if (!x) {
                resolve(null);
                return;
            }
            window.reactComponents.push({
                root: root,
                component: x,
                container: container,
            });
            resolve(x);
        } }, cmpt));
    root.render(component);
});
export const reactForceAllUpdate = () => {
    window.lastForcedReactUpdate = _.now();
    window.reactComponents = _.filter(window.reactComponents, x => {
        try {
            ;
            x.component.forceUpdate();
            return true;
        }
        catch (error) {
            return false;
        }
    });
};
export const unmountReactOnElement = (el) => {
    window.reactComponents = window.reactComponents.filter(x => {
        if (x.container === el) {
            x.root?.unmount();
            return false;
        }
        return true;
    });
};
export const getReactComponent = (elOrQuery) => {
    const el = Do(() => {
        if (typeof elOrQuery === 'string') {
            return document.querySelector(elOrQuery);
        }
        return elOrQuery;
    });
    if (el == null) {
        return null;
    }
    const key = Object.keys(el)?.find(x => x.startsWith('__reactFiber$') || x.startsWith('__reactContainer$'));
    if (!key) {
        return null;
    }
    const elWithKey = el;
    return (elWithKey[key]
        ?.return?.stateNode ??
        elWithKey[key]?.stateNode ??
        null);
};
export const bindMulti = (obj, keys) => {
    if (typeof keys === 'string') {
        keys = _.compact(_.map(keys.split(' '), x => x.trim()));
    }
    keys.forEach((k) => {
        if (obj[k] == null) {
            throw Error(`Cannot find method \`${k}\``);
        }
        obj[k] = obj[k].bind(obj);
    });
};
export const bindMethods = (obj, ...methods) => {
    methods.forEach(func => {
        if (func.name) {
            obj[func.name] = func.bind(obj);
        }
    });
};
export const j2rLabel = (label, cl, title, comp) => {
    if (!_.isString(title)) {
        comp = title;
        title = null;
    }
    return {
        tag: 'label',
        key: label || cl,
        cl: BuildClass({
            [cl]: true,
            'j2r-label': true,
        }),
        children: [
            {
                tag: 'span',
                key: 'label',
                cl: 'lbl',
                text: label,
                title: title ?? label,
            },
            _.assign(comp?.() ?? {}, { key: 'comp' }),
        ],
    };
};
export const j2rtxt = (key, text, tooltip) => ({
    tag: 'span',
    key,
    text: String(text ?? ''),
    title: String(tooltip ?? text ?? ''),
});
export const j2rHeadingCell = (reactEl, key, lbl, sKey, sKeyRev, sKeyRevDef) => {
    if (sKey == null) {
        sKey = 'sortingKey';
    }
    if (sKeyRev == null) {
        sKeyRev = 'sortingReverse';
    }
    return {
        tag: 'span',
        key,
        title: '',
        cl: BuildClass({
            'heading-cell-inner': true,
            sorted: key === reactEl.state[sKey],
            'sort-asc': key === reactEl.state[sKey] && !reactEl.state[sKeyRev],
            'sort-dsc': key === reactEl.state[sKey] && reactEl.state[sKeyRev],
        }),
        text: lbl ?? key,
        onClick: () => reactEl.setState((s) => ({
            [sKey]: key,
            [sKeyRev]: Do(() => {
                if (s[sKey] === key) {
                    return !s[sKeyRev];
                }
                return sKeyRevDef ?? false;
            }),
        })),
    };
};
export const j2rHeadingCellFunctional = (state, key, lbl, sKey, sKeyRev, onClick) => {
    let sKeyStr;
    let sKeyRevStr;
    if (typeof lbl === 'function') {
        onClick = lbl;
        lbl = null;
    }
    if (typeof sKey === 'function') {
        onClick = sKey;
        sKeyStr = 'sortingKey';
    }
    else {
        sKeyStr = sKey ?? 'sortingKey';
    }
    if (typeof sKeyRev === 'function') {
        onClick = sKeyRev;
        sKeyRevStr = 'sortingReverse';
    }
    else {
        sKeyRevStr = sKeyRev ?? 'sortingReverse';
    }
    return {
        tag: 'span',
        key,
        cl: BuildClass({
            'heading-cell-inner': true,
            sorted: key === state[sKeyStr],
            'sort-asc': key === state[sKeyStr] &&
                !state[sKeyRevStr],
            'sort-dsc': Boolean(key === state[sKeyStr] &&
                state[sKeyRevStr]),
        }),
        text: (lbl ?? key),
        onClick: () => (onClick ?? _.noop)({
            [sKeyStr]: key,
            [sKeyRevStr]: state[sKeyStr] === key &&
                !state[sKeyRevStr],
        }),
    };
};
export const j2rHeadingCellTooltip = (reactEl, key, lbl, title, sKey, sKeyRev, sKeyRevDef) => {
    const el = j2rHeadingCell(reactEl, key, lbl, sKey, sKeyRev, sKeyRevDef);
    el.title = title;
    return el;
};
export const j2rProps = (obj, prop, cmpt) => {
    let cmptResolved;
    cmptResolved = _.isFunction(cmpt)
        ? cmpt()
        : cmpt;
    if (cmptResolved.onUpdateStatic == null) {
        cmptResolved.onUpdateStatic = false;
    }
    const fnKey = `setStateProp_${prop}`;
    const objRecord = obj;
    if (objRecord[fnKey] == null) {
        objRecord[fnKey] = Do(() => {
            let fn = null;
            if (cmptResolved.onUpdateStatic) {
                fn = cmptResolved.onUpdate ?? null;
            }
            if (fn == null) {
                fn = Do(() => {
                    const fnKeyInner = obj.updateState != null ? 'updateState' : 'setState';
                    if (objRecord[fnKeyInner] == null) {
                        console.trace('No update state method for', obj);
                    }
                    const fnInner = objRecord[fnKeyInner].bind(obj);
                    if (cmptResolved.tag === J2rComboBox) {
                        return ((v) => {
                            if (typeof v === 'object' && v !== null && 'value' in v) {
                                fnInner({
                                    [prop]: v.value,
                                });
                                return;
                            }
                            fnInner({ [prop]: v });
                        });
                    }
                    return (v) => {
                        fnInner({ [prop]: v });
                    };
                });
            }
            if (fn == null) {
                return () => { };
            }
            return fn.bind(obj);
        });
    }
    return _.assign(cmptResolved, {
        key: `cmpt-inner-${prop}`,
        value: obj.state[prop],
        onUpdate: Do(() => {
            if (cmptResolved.onUpdateStatic) {
                return objRecord[fnKey];
            }
            return cmptResolved.onUpdate ?? objRecord[fnKey];
        }),
    });
};
export const j2rCmpt = (obj, prop, lbl, cmpt) => {
    if (cmpt == null && lbl == null) {
        cmpt = { tag: J2rText };
        lbl = prop;
    }
    else if (cmpt == null && typeof lbl === 'string') {
        cmpt = { tag: J2rText };
    }
    else if (cmpt == null && (typeof lbl === 'object' || typeof lbl === 'function')) {
        cmpt = lbl;
        lbl = prop;
    }
    else if (cmpt == null) {
        cmpt = lbl;
        lbl = prop;
    }
    const lblStr = typeof lbl === 'string' ? lbl : prop;
    const el = j2rLabel(lblStr, '', () => j2rProps(obj, prop, cmpt));
    const lblKey = typeof lbl === 'string' ? lbl : prop;
    el.key = el.key || `${prop}-${lblKey}`;
    return el;
};
class ReactFlyoutContent extends React.Component {
    render() {
        return (React.createElement("div", { key: "flyout-wrapper", className: BuildClass({
                'react-flyout-wrapper': true,
                'no-title': !this.props.title,
            }) },
            ConditionalObject(Boolean(this.props.title), React.createElement("div", { className: "heading-outer" }, this.props.title)),
            React.createElement("div", { className: "flyout-body-inner" }, this.props.content())));
    }
}
export const reactFlyout = (title, size, cmpt, custom_params) => {
    const params = {
        size: size,
        callback: async (flyout) => reactRender(flyout.Element, React.createElement(ReactFlyoutContent, { title: title, content: () => React.cloneElement(j2r(cmpt), {
                key: 'flyout-content',
                flyout: flyout,
            }) })),
    };
    return newSystemFlyout({ ...custom_params, ...params });
};
export const reactFlyoutFunc = (title, size, cmpt, custom_params) => {
    const params = {
        size: size,
        callback: async (flyout) => reactRender(flyout.Element, React.createElement(ReactFlyoutContent, { title: title, content: () => cmpt(flyout) })),
    };
    return newSystemFlyout({ ...custom_params, ...params });
};
export const reactFlyoutNew = (title, size, cmpt, custom_params) => reactFlyout(title, size, cmpt, custom_params);
export const j2rLoadingFlyout = ({ cl, title, size, promise, }) => {
    if (size == null) {
        size = [280, 240];
    }
    if (title == null) {
        title = 'Loading...';
    }
    const flyout = reactFlyout(title, size, {
        tag: J2rLoadingSpinner,
        key: 'spinner',
        cl: BuildClass({
            [cl ?? '']: true,
            'j2r-loading-flyout': true,
        }),
        size: 'large',
    });
    (promise ?? Promise.resolve()).then(() => {
        flyout.Close();
    });
};
export const j2rResponseDiv = (is_loading, message_text) => ({
    cl: 'lblResponse cntr',
    key: 'loading-response',
    children: [
        is_loading
            ? {
                tag: J2rLoadingSpinner,
                key: 'inner-spinner',
                size: 'small',
            }
            : message_text == null || typeof message_text === 'string'
                ? {
                    key: 'inner-text',
                    text: message_text ?? '',
                }
                : _.isArray(message_text)
                    ? {
                        key: 'inner-cmpt-items',
                        children: message_text,
                    }
                    : _.assign({}, message_text, { key: 'inner-cmpt-raw' }),
    ],
});
export const j2rButtonResponseSet = (is_loading, message_text, extra_args, buttons) => {
    if (buttons == null) {
        if (extra_args && !('types' in extra_args)) {
            buttons = extra_args;
            extra_args = {};
        }
        else {
            buttons = undefined;
        }
    }
    const extraArgsTyped = (extra_args && 'types' in extra_args ? extra_args : {});
    const types = {};
    const submits = ['save', 'submit', 'go', 'login', 'sign in', 'add', 'verify', 'send'];
    const standards = ['reset', 'cancel', 'undo', 'reorder'];
    const deletes = ['delete', 'ignore'];
    _.forEach(submits, x => {
        types[x] = 'submit';
    });
    _.forEach(standards, x => {
        types[x] = 'standard';
    });
    _.forEach(deletes, x => {
        types[x] = 'delete';
    });
    let count = -1;
    return j2rButtonResponseSetAdvanced({
        loading: is_loading,
        message: typeof message_text === 'boolean' ? null : message_text,
        buttons: _.map(buttons ?? {}, (v, k) => ({
            label: k,
            disabled: false,
            onClick: v,
            type: Do(() => {
                if (extraArgsTyped?.types != null) {
                    count += 1;
                    return extraArgsTyped.types[count] ?? 'standard';
                }
                return types[k.toLowerCase()] || 'standard';
            }),
        })),
    });
};
export const j2rButtonResponseSetAdvanced = (obj) => ({
    key: 'button-loading-response-wrapper',
    children: [
        {
            cl: 'cntr buttons',
            key: 'button-set',
            children: _.map(obj.buttons, btn => ({
                tag: J2rButton,
                key: btn.label,
                label: btn.label,
                type: btn.type,
                disabled: btn.onClick && (obj.loading || btn.disabled),
                onClick: btn.onClick,
            })),
        },
        j2rResponseDiv(obj.loading, obj.message),
    ],
});
export class J2rLoadingSpinner extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return j2r(() => {
            if (this.props.size === 'small') {
                return {
                    tag: 'img',
                    cl: BuildClass({
                        [this.props.cl ?? '']: true,
                        'loading-spinner': true,
                        'loading-spinner-new': true,
                    }),
                    src: '/static/img/svg/ajax-small.svg',
                    title: 'Loading...',
                };
            }
            else if (this.props.size === 'large') {
                return {
                    key: 'loadingSpinnerLarge',
                    cl: BuildClass({
                        [this.props.cl ?? '']: true,
                        loadingSpinnerLarge: true,
                    }),
                    children: [
                        { key: 'blue', cl: 'circle blue' },
                        { key: 'red', cl: 'circle red' },
                        { key: 'yellow', cl: 'circle yellow' },
                        { key: 'green', cl: 'circle green' },
                    ],
                };
            }
            throw new Error('Invalid size type for AJAX loading component');
        });
    }
}
export class J2rText extends React.PureComponent {
    element;
    constructor(props) {
        super(props);
        this.element = React.createRef();
        this.state = {
            value: String(this.props.value ?? ''),
            focused: false,
        };
        if (this.props.autoExpand && !this.props.multiLine) {
            console.warn('In `J2rText`, `autoExpand` is true but `multiLine` is not?');
        }
    }
    componentDidMount() {
        timer(() => {
            this.resizeToFitContent();
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: String(this.props.value ?? '') }, () => {
                this.resizeToFitContent();
            });
        }
    }
    resizeToFitContent() {
        if (!this.props.autoExpand) {
            return;
        }
        const el = this.element.current;
        if (el == null) {
            return;
        }
        const style = window.getComputedStyle(el);
        const btop = style.borderTopWidth ?? '0px';
        const bbot = style.borderBottomWidth ?? '0px';
        el.style.height = '0px';
        el.style.overflowY = 'hidden';
        let h = el.scrollHeight;
        if (h < 28) {
            h = 28;
        }
        const heightStyle = `calc(${h}px + ${btop} + ${bbot})`;
        el.style.overflowY = '';
        el.style.height = heightStyle;
    }
    render() {
        return j2r({
            tag: this.props.multiLine ? 'textarea' : 'input',
            id: this.props.id,
            cl: BuildClass({
                [this.props.cl ?? '']: true,
                tb2: true,
                disabled: this.props.disabled ?? false,
            }),
            ref: this.element,
            type: this.props.type ?? undefined,
            disabled: this.props.disabled,
            placeholder: this.props.placeholder ?? '',
            tabIndex: this.props.tabIndex ?? undefined,
            autoFocus: this.props.autoFocus ?? undefined,
            maxLength: this.props.maxLength ?? undefined,
            readOnly: this.props.readOnly ?? undefined,
            value: this.state['value'] ?? '',
            title: this.props.title,
            autoComplete: this.props.autoComplete,
            onKeyDown: this.props.onKeyDown,
            style: this.props.style,
            onFocus: (e) => {
                if (this.props.focusOnClick && !this.state['focused']) {
                    this.element.current?.select();
                }
                this.setState({ focused: true }, () => {
                    ;
                    (this.props.onFocus ?? _.noop)(e);
                });
            },
            onBlur: (e) => {
                this.setState({
                    focused: false,
                    value: (this.props.fixerChange ?? ((v) => v))(this.state['value'] ?? ''),
                }, () => {
                    if (this.props.fixerChange != null) {
                        ;
                        (this.props.onUpdate ?? _.noop)(this.state['value']);
                    }
                    ;
                    (this.props.onBlur ?? _.noop)(e);
                });
            },
            onChange: (e) => {
                const value = (this.props.fixer ?? ((v) => v))(e.target.value);
                this.setState({ value }, () => {
                    this.resizeToFitContent();
                    (this.props.onUpdate ?? _.noop)(this.state['value']);
                });
            },
        });
    }
    focus() {
        this.element.current?.focus();
    }
}
export class J2rTime extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return j2r({
            tag: J2rText,
            cl: 'time',
            maxLength: 5,
            value: this.props.value,
            onUpdate: this.props.onUpdate,
            disabled: this.props.disabled,
            placeholder: this.props.placeholder,
            fixerChange: (v) => validateTime(v) ?? '',
            focusOnClick: true,
        });
    }
}
export class J2rDropdown extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.getValue, this.sanitizeValue]);
        this.state = { value: this.props.value };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.sanitizeValue(this.props.value) });
        }
    }
    getValue(el) {
        const rawValue = Do(() => {
            if (this.props.multiple) {
                return fsmData($(el).find('option').toArray(), {
                    filter: (el) => el.selected,
                    map: (el) => el.value ?? 1,
                });
            }
            return el.value;
        });
        return rawValue;
    }
    sanitizeValue(v) {
        const sanitizeNode = (x) => {
            if (!x) {
                return null;
            }
            else if (this.props.integer) {
                return +x || null;
            }
            return x;
        };
        if (this.props.multiple && Array.isArray(v)) {
            return v.map((x) => sanitizeNode(x));
        }
        return sanitizeNode(v);
    }
    render() {
        return j2r({
            tag: 'select',
            cl: BuildClass({
                tb2: true,
                [this.props.cl ?? '']: true,
                disabled: this.props.disabled ?? false,
                multiple: this.props.multiple ?? false,
            }),
            multiple: this.props.multiple ? 'multiple' : undefined,
            disabled: this.props.disabled ? 'disabled' : undefined,
            value: this.state['value'] ?? '',
            children: Do(() => {
                if (!this.props.options) {
                    return [];
                }
                const O = this.props.options.map(x => {
                    if (Array.isArray(x)) {
                        return this.buildOption(x);
                    }
                    if (typeof x === 'object' &&
                        x !== null &&
                        'label' in x &&
                        'children' in x &&
                        typeof x.label === 'string' &&
                        Array.isArray(x.children)) {
                        return this.buildOption({
                            label: x.label,
                            children: x.children,
                        });
                    }
                    throw new Error('Invalid option type');
                });
                if (this.props.nullable != null) {
                    const nullableText = typeof this.props.nullable === 'boolean'
                        ? this.props.nullable
                            ? '--'
                            : ''
                        : this.props.nullable;
                    O.unshift(this.buildOption(['', nullableText]));
                }
                return O;
            }),
            onChange: (e) => {
                const value = this.getValue(e.target);
                const sanitized = this.sanitizeValue(value);
                this.setState({ value }, () => {
                    const callbackValue = Array.isArray(sanitized)
                        ? (sanitized[0] ?? null)
                        : sanitized;
                    (this.props.onUpdate ?? _.noop)(callbackValue);
                });
            },
        });
    }
    buildOption(opt) {
        if (opt.constructor === Array) {
            const textValue = opt[1];
            const text = typeof textValue === 'string' || typeof textValue === 'number'
                ? textValue
                : String(textValue ?? '');
            return {
                tag: 'option',
                key: typeof opt[0] === 'string' || typeof opt[0] === 'number'
                    ? opt[0]
                    : String(opt[0] ?? ''),
                value: opt[0],
                text,
            };
        }
        if ('label' in opt &&
            'children' in opt &&
            typeof opt === 'object' &&
            opt !== null) {
            const optGroup = opt;
            return {
                tag: 'optgroup',
                label: optGroup.label,
                key: `group-${optGroup.label}`,
                children: optGroup.children.map((o) => {
                    if (Array.isArray(o)) {
                        return this.buildOption(o);
                    }
                    if (typeof o === 'object' &&
                        o !== null &&
                        'label' in o &&
                        'children' in o) {
                        return this.buildOption(o);
                    }
                    throw new Error('Invalid option type in optgroup');
                }),
            };
        }
        throw new Error('Invalid option type');
    }
}
export class J2rCheckbox extends React.PureComponent {
    checkbox;
    constructor(props) {
        super(props);
        this.checkbox = React.createRef();
        Bindings(this, [this.evFocus, this.evBlur]);
        this.state = {
            value: props.value ?? false,
            focused: false,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value ?? false });
        }
    }
    render() {
        return j2r({
            cl: BuildClass({
                'material-checkbox-wrapper': true,
                [this.props.cl ?? '']: true,
                focused: this.state['focused'] ?? false,
                disabled: this.props.disabled ?? false,
                standalone: this.props.standalone ?? false,
            }),
            title: this.props.title ? this.props.title : undefined,
            children: [
                {
                    key: 1,
                    cl: BuildClass({
                        'material-checkbox': true,
                        selected: this.state['value'] ?? false,
                        disabled: this.props.disabled ?? false,
                    }),
                    text: !this.props.labelChildren
                        ? (this.props.label ?? '')
                        : undefined,
                    children: this.props.labelChildren,
                },
                {
                    key: 2,
                    tag: 'input',
                    ref: this.checkbox,
                    type: 'checkbox',
                    tabIndex: this.props.tabIndex,
                    disabled: this.props.disabled ?? false,
                    readOnly: this.props.readOnly ?? false,
                    checked: this.state['value'] ?? false,
                    onChange: () => {
                        if (this.checkbox.current) {
                            this.setState({ value: this.checkbox.current.checked }, () => {
                                ;
                                (this.props.onUpdate ?? _.noop)(this.state['value'] ?? false);
                            });
                        }
                    },
                    onFocus: this.evFocus,
                    onBlur: this.evBlur,
                },
            ],
            onClick: (e) => {
                if (this.props.disabled || this.props.readOnly) {
                    return;
                }
                if (this.checkbox.current) {
                    this.checkbox.current.focus();
                    this.checkbox.current.checked = !this.state['value'];
                    (this.props.onClick ?? _.noop)(e);
                    if (this.props.triggerClick) {
                        this.setState({ value: this.checkbox.current.checked }, () => {
                            ;
                            (this.props.onUpdate ?? _.noop)(this.state['value'] ?? false);
                        });
                    }
                }
            },
        });
    }
    evFocus() {
        this.setState({ focused: true });
    }
    evBlur() {
        this.setState({ focused: false });
    }
    focus() {
        this.checkbox.current?.focus();
    }
}
export class J2rSidebarControl extends React.Component {
    listElement;
    constructor(props) {
        super(props);
        this.listElement = React.createRef();
        this.state = { value: props.value ?? -1 };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value ?? -1 });
        }
    }
    componentDidMount() {
        const fn = (v) => {
            if (v != null) {
                this.setState({ scrollPosition: v });
            }
        };
        const dbfn = _.throttle(fn, 50, {
            leading: true,
            trailing: true,
        });
        this.listElement.current?.addEventListener('scroll', () => {
            dbfn(this.listElement.current?.scrollTop);
        });
    }
    render() {
        return (React.createElement("div", { className: BuildClass({
                'j2r-sidebar-control': true,
                [this.props.cl ?? '']: true,
            }) },
            this.buildSidebar(),
            this.buildForm()));
    }
    buildSidebar() {
        return (React.createElement("div", { className: "sidebar", ref: this.listElement, style: {
                minWidth: `${this.props.width ?? 160}px`,
                maxWidth: `${this.props.width ?? 160}px`,
            } }, this.getSidebarRows()));
    }
    buildForm() {
        let M;
        if (this.state['value'] || this.props.showFormOnNull) {
            M = j2r(this.props.form(this.state['value']));
        }
        else if (this.props.stubMessage != null) {
            M = (React.createElement("div", { className: "stub-message-wrapper" },
                React.createElement("div", { className: "stub-message" }, this.props.stubMessage)));
        }
        else {
            M = React.createElement("div", null);
        }
        return React.cloneElement(M, {
            key: M.key ?? 'form',
            className: BuildClass({
                [M.props.className]: true,
                form: true,
            }),
        });
    }
    getSidebarRows() {
        let items = this.props.items ?? [];
        if (this.props.newLabel) {
            items = items.concat({
                value: -1,
                cl: 'new',
                text: this.props.newLabel,
            });
        }
        const rows = items.map(item => j2r({
            key: item.value,
            cl: BuildClass({
                item: true,
                [item.cl ?? '']: true,
                selected: item.value === this.state['value'],
            }),
            text: item.text,
            title: item.title ?? item.text,
            children: item.children,
            onClick: () => {
                this.setState({ value: item.value }, () => {
                    ;
                    (this.props.onUpdate ?? _.noop)(item.value);
                });
            },
        }));
        return rows;
    }
}
export class J2rListAddRemove extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.save, this.reset, this.add, this.remove]);
        this.state = {
            value: undefined,
            isLoading: false,
            message: '',
            selected: _.uniq(this.props.selected ?? []),
        };
    }
    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.selected, this.props.selected)) {
            this.setState({ selected: this.props.selected ?? [] });
        }
    }
    render() {
        return j2r({
            cl: 'j2r-list-add-remove',
            children: [
                this.buildForm(),
                this.state.selected.length + (this.props.selected?.length ?? 0) > 0
                    ? this.buildSelected()
                    : this.buildSelectedStub(),
                !this.props.overrideButtons ? this.buildButtons() : undefined,
            ],
        });
    }
    buildSelectedStub() {
        return {
            cl: 'j2rlist selected noselect',
            key: 'selected-stub',
            children: [
                {
                    key: 'stub-text',
                    cl: 'error_msg_2 cntr',
                    text: 'List Empty',
                },
            ],
        };
    }
    buildSelected() {
        return {
            tag: J2rListComponent,
            cl: BuildClass({
                'selected-items noselect': true,
                'no-buttons': this.props.overrideButtons ?? false,
            }),
            key: 'selected',
            items: fsmData(_.uniq(this.state.selected.concat(this.props.selected ?? [])), {
                sort: (x) => {
                    const prefix = !(this.props.selected ?? []).includes(x)
                        ? '** '
                        : '';
                    return prefix + this.props.nameMapping(x);
                },
                map: (x) => this.buildRow(x),
            }),
        };
    }
    buildRow(x) {
        const is_new = !(this.props.selected ?? []).includes(x);
        const is_del = !this.state.selected.includes(x);
        return {
            value: x,
            cl: BuildClass({
                'list-row': true,
                new: is_new,
                del: is_del,
            }),
            children: [
                {
                    tag: 'span',
                    key: 'lbl',
                    cl: 'lbl',
                    text: this.props.nameMapping(x),
                    title: this.props.nameMapping(x),
                },
                {
                    cl: 'indicator',
                    key: 'indicator',
                    children: [''],
                    title: Do(() => {
                        if (is_new) {
                            return 'Adding to list (after you click save)';
                        }
                        else if (is_del) {
                            return 'Deleting from list (after you click save)';
                        }
                        return undefined;
                    }),
                },
                {
                    tag: 'span',
                    key: 'delete-button',
                    cl: BuildClass({
                        'delete-button': true,
                        add: is_del,
                    }),
                    children: [
                        {
                            tag: 'img',
                            key: 'icon',
                            src: '/static/img/cross.png',
                        },
                    ],
                    onClick: () => {
                        if (is_del) {
                            this.add(x);
                        }
                        else {
                            this.remove(x);
                        }
                    },
                },
            ],
        };
    }
    buildForm() {
        return {
            cl: 'add-new-item',
            key: 'add-new-item',
            children: [
                {
                    tag: J2rComboBox,
                    key: 'dropdown',
                    value: this.state.value,
                    placeholder: this.props.placeholder ?? 'Add Item...',
                    options: fsmData(this.props.sourceIDs, {
                        filter: (x) => !this.state.selected.includes(x),
                        sort: (x) => this.props.nameMapping(x),
                        map: (x) => ({
                            value: x,
                            text: this.props.nameMapping(x),
                        }),
                    }),
                    onUpdate: (v) => {
                        if (v.value != null) {
                            this.add(v.value);
                        }
                        this.setState({ value: v.value ?? undefined }, () => {
                            this.setState({ value: undefined });
                        });
                    },
                },
            ],
        };
    }
    buildButtons() {
        return j2rButtonResponseSet(this.state.isLoading, this.state.message, {
            Save: this.save,
            Reset: this.reset,
        }, undefined);
    }
    logUpdate() {
        ;
        (this.props.onUpdate ?? _.noop)(this.state.selected);
    }
    add(k) {
        this.setState((s) => ({ selected: _.uniq(s.selected.concat(k)) }), () => {
            this.logUpdate();
        });
    }
    remove(k) {
        this.setState((s) => ({
            selected: _.uniq(s.selected.filter(x => x !== k)),
        }), () => {
            this.logUpdate();
        });
    }
    reset() {
        const delta = {
            message: '',
            selected: _.uniq(this.props.selected),
        };
        this.setState(delta, () => {
            this.logUpdate();
        });
    }
    save() {
        const delta = {
            added: _.filter(this.state.selected, x => !(this.props.selected ?? []).includes(x)),
            removed: _.filter(this.props.selected ?? [], x => !this.state.selected.includes(x)),
        };
        if (delta.added.length + delta.removed.length === 0) {
            this.setState({ message: 'Nothing changed' });
            timer(1000, () => {
                this.setState({ message: '' });
            });
            return;
        }
        this.setState({
            isLoading: true,
            message: '',
        });
        if (this.props.onSave) {
            this.props.onSave(delta, (msg) => timer(() => {
                this.setState({ isLoading: false });
                if (msg === true) {
                    timer(() => {
                        this.reset();
                    });
                }
                else {
                    this.setState({ message: msg });
                }
            }));
        }
    }
}
export class J2rTooltip extends React.Component {
    static defaultProps = {
        elTag: 'div',
        cl: '',
        options: {},
    };
    element;
    instance;
    constructor(props) {
        super(props);
        this.element = React.createRef();
        this.instance = null;
    }
    componentDidMount() {
        this.instance = this.rebuild();
    }
    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.options, prevProps.options)) {
            if (this.instance) {
                this.instance.destroy();
            }
            this.instance = this.rebuild();
            return;
        }
        if (prevProps.title !== this.props.title && this.instance) {
            this.instance.setContent(this.props.title);
        }
    }
    componentWillUnmount() {
        if (this.instance) {
            this.instance.destroy();
        }
    }
    rebuild() {
        if (!this.element.current) {
            return null;
        }
        const result = tippy(this.element.current, _.assign({ content: this.props.title }, this.getDefaultOptions(), this.props.options));
        return (result.instances?.[0] ?? null);
    }
    getDefaultOptions() {
        return {
            delay: 1000,
            arrow: true,
            touchHold: true,
        };
    }
    render() {
        return j2r(() => {
            const isText = typeof this.props.content === 'string';
            const el = {
                tag: this.props.elTag,
                ref: this.element,
                cl: `tippy-wrapper ${this.props.cl}`,
                children: !isText ? this.props.content : undefined,
                text: isText ? this.props.content : undefined,
            };
            const used = ['title', 'options', 'content', 'elTag', 'cl'];
            const elRecord = el;
            fsmData(_.keys(this.props), {
                filter: (x) => !used.includes(x),
                map: (x) => {
                    elRecord[x] = this.props[x];
                },
            });
            return el;
        });
    }
}
export class J2rHelp extends React.Component {
    static defaultProps = { cl: '' };
    constructor(props) {
        super(props);
    }
    render() {
        return j2r({
            tag: J2rTooltip,
            elTag: 'img',
            cl: `help-tooltip-global ${this.props.cl}`,
            alt: 'Help',
            tabIndex: -1,
            src: '/static/img/svg/small-help-icon.svg',
            title: this.props.title,
            options: { delay: 200 },
            content: '',
        });
    }
}
export class J2rModalPortal extends React.Component {
    element;
    constructor(props) {
        super(props);
        this.element = document.createElement('div');
        this.element.classList.add('j2r-modal');
        if (this.props.cl != null) {
            this.element.classList.add(this.props.cl);
        }
    }
    componentDidMount() {
        document.body.appendChild(this.element);
    }
    componentWillUnmount() {
        document.body.removeChild(this.element);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.cl !== this.props.cl) {
            if (prevProps.cl != null) {
                this.element.classList.remove(prevProps.cl);
            }
            if (this.props.cl != null) {
                this.element.classList.add(this.props.cl);
            }
        }
    }
    render() {
        return ReactDOM.createPortal(this.props.children, this.element);
    }
}
export class J2rLabelOpenExternal extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.openExternal]);
    }
    render() {
        return (React.createElement("div", { className: BuildClass({
                [this.props.cl ?? '']: true,
                'text-label-open-external': true,
            }) },
            React.createElement(J2rText, { key: "lbl", disabled: true, title: this.props.title, value: this.props.label, placeholder: this.props.placeholder }),
            React.createElement(J2rButton, { key: "btn", cl: "open-external", type: "borderless", inner: [React.createElement("img", { src: "/static/img/svg/open-external.svg" })], onClick: this.openExternal })));
    }
    openExternal() {
        ;
        (this.props.onClick ?? _.noop)();
    }
}
//# sourceMappingURL=component-react.js.map